import React from "react";
import { Link } from "react-router-dom";

interface Props {
    details: {
        vote_count: number;
        vote_average: number;
        media_type?: string;
        id: number;
    };
    link: string;
}

function formatRatingCount(count: number) {
    return count > 999 ? `${(count / 1000).toFixed(1)}K` : count;
}

const Ratings = ( { details, link }: Props ) => {
    return (
        <div className='ratings'>
            {details.vote_count > 0 &&
                <Link to={`https://www.themoviedb.org/${link}`} target="_blank" className='rating'>
                    <img className='icon' src='/assets/tmdb.svg' alt='TMDB Icon' />
                    <div className='values'>
                        <span className='value'>{Math.round(details.vote_average * 10)}%</span>
                        <span className='count'>{formatRatingCount(details.vote_count)}</span>
                    </div>
                </Link>
            }
        </div>
    )
}

export default Ratings;